import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { HashLink } from 'react-router-hash-link';

const drawerWidth = 240;

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'left' }}>
      
      <Divider />
      
      <HashLink className='navItemDrawer' smooth to="/#leistungen">Leistungen</HashLink>
      <HashLink className='navItemDrawer' smooth to="/#notare">Notare</HashLink>
      <HashLink className='navItemDrawer' smooth to="/Team">Team</HashLink>
      <HashLink className='navItemDrawer' smooth to="#kontakt">Kontakt</HashLink>
      <HashLink className='navItemDrawer flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
      

      {/* <div className="heroCTAWrapperNav">
                                            <Button href="#" target='_blank' variant='contained' className='mandantenCTATopNav'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
                                        </div> */}
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box>
      <CssBaseline />
      <AppBar component="nav" className='navbar alt'>
        <Toolbar>
        <img
          src="menu-icon.png"
          className='menuIcon' 
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }} />
          <Typography variant="h6" component="div" className='drawerTitle' sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }} >
            <a href='/'> <img src="HT-Logo.png" className='brandLogo' /> </a>
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'flex' } }} className="navLinksBox">
             
             <HashLink smooth to="/#leistungen">Leistungen</HashLink>
            <HashLink smooth to="/#notare">Notare</HashLink>
            <HashLink smooth to="/Team">Team</HashLink>
            <HashLink smooth to="#kontakt">Kontakt</HashLink>
            <HashLink smooth className="navflex" to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>

             {/* <div className="heroCTAWrapperNav">
                                            <Button href="#" target='_blank' variant='contained' className='mandantenCTATopNav'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
                                        </div> */}
          </Box>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          anchor={'right'}
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

    </Box>
  );
}

export default DrawerAppBar;